import { lazy, Suspense } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Concept from './components/Concept';
import Pricing from './components/Pricing';
import SisterStores from './components/SisterStores';
import Access from './components/Access';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';
import BackToTopButton from './components/BackToTopButton';

const VirtualTour = lazy(() => import('./components/VirtualTour'));

export default function Home() {
  return (
    <div
      className="min-h-screen bg-[#0A0A0F] overflow-x-hidden"
      style={{ fontFamily: "'Shippori Mincho', serif" }}
    >
      <Navbar />
      <main>
        <Hero />
        <Concept />
        <Suspense
          fallback={
            <section id="interior" className="bg-[#0A0A0F] py-24 md:py-36">
              <div className="max-w-7xl mx-auto px-6 md:px-10 flex justify-center">
                <div className="w-8 h-8 border border-[#C9A84C]/30 border-t-[#C9A84C] rounded-full animate-spin" />
              </div>
            </section>
          }
        >
          <VirtualTour />
        </Suspense>
        <Pricing />
        <SisterStores />
        <Access />
        <CtaSection />
      </main>
      <BackToTopButton />
      <Footer />
    </div>
  );
}
